<template>
	<div class="col-12 my-3" :class="$parent.transfetWallet?'d-none':' '">
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <h2 class="my-3">{{$t('loyal_List_Trans_History')}}</h2>
            <div class="whiteBG table-responsive">
                <table class="table pmmTable">
                    <thead>
                        <tr>
                            <th>{{$t('loyal_List_Date')}}</th>
                            <th>{{$t('loyal_List_Activity')}}</th>
                            <th>{{$t('loyal_List_Volume')}}</th>
                            <th>{{$t('loyal_List_Points')}}</th>
                            <th>{{$t('loyal_List_Cr_Db')}}</th>
                        </tr>
                    </thead>
                    <tbody v-if="(!pageLoader && loyalityCardTxn != '' && loyalityCardTxn.totalRecords > 0)">
                        <tr v-for="list in loyalityCardTxn.records">
                            <td>{{list.created  | moment("DD MMMM YYYY")}}</td>
                            <td>{{list.activity}}</td>
                            <td ><p v-if="list.volume != '' && list.volume != null">{{list.volume}}</p><p v-else>-</p></td>
                            <td>{{list.points}}</td>
                            <td>{{$env_var.transaction_type[parseInt(list.transaction_type)]}}</td>
                        </tr>
                    </tbody>
                    <loader-component :pageloader_value="pageLoader" :type="'table'" :colspan="'5'" :list="loyalityCardTxn" v-else></loader-component>
                </table>
                <pagination :getList="loyalityCardTxn" :limit="pageLimit" v-if="loyalityCardTxn.totalRecords > 0"></pagination>
            </div>
    </div>
</template>
<script>
    export default {
        name: 'Wallet',
        data() {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,

                pageLimit : '10',
                search : '',
                page : '1', 
            }
        },
        methods:{
            listing(){
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: this.search,
                        page: this.page,
                        perPage: parseInt(this.pageLimit),
                    } ,'localParams' : {'parameter' : this}
                }
                this._runGetLoyalityTxnList(inputJson)
            }
        }
      
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/loyality/loyality_txn_list.vue